

export  class BgCloudBonusBookOfTime
{
    private parent:PIXI.Container=new PIXI.Container();
    private maxParticlesCount:number=0;//"Cloud.H03lowRes.2k.png"
    private imageName:Array<string>=["cloudpuff.png","Cloud.H03lowRes.2k.png"];
    private particleSprite:Array<PIXI.Sprite>=[];
    private particleTween:Array<PIXI.tween.Tween>=[];
    private linearTween:boolean=true;

   
    constructor(parent:PIXI.Container,maxParticlesCount:number,gameScreenSize:Array<number>,flipAnimationAxisX:boolean)
    {
        parent.addChild(this.parent);
        this.maxParticlesCount=maxParticlesCount;

        const filter = new PIXI.filters.ColorMatrixFilter();
        this.parent.filters=[filter];
        filter.hue(50,true)


        for (let i = 0; i <this.maxParticlesCount; i++) {

          let randomImageName=this.imageName[Math.floor(Math.random()*this.imageName.length)]
            //create sprite
            this.particleSprite[i]= new PIXI.Sprite(
                PIXI.Texture.fromFrame(randomImageName)
              );
              this.parent .addChild(this.particleSprite[i]);
              this.particleSprite[i].anchor.set(0.5);
              this.particleSprite[i].alpha=0;


            
            //   this.particleSprite[i].tint =0x224d72;

              //create tween
                this.particleTween[i]= PIXI.tweenManager.createTween(this.particleSprite[i]);
                let randScale=Math.random()*2+1;
                let targetX=-gameScreenSize[0]/2;
                if(flipAnimationAxisX)
                {
                    // targetX=gameScreenSize[0]+gameScreenSize[0]/2
                    targetX=gameScreenSize[0];
                }
                else
                {
                    // targetX=-gameScreenSize[0]/2
                    targetX=0;
                }
                // console.log("X", targetX)
                if(this.linearTween)
                {
                    this.particleTween[i]
                    .from({
                    
                      x: gameScreenSize[0]/2,
                      alpha:1,
                      y:Math.random()*500,
                      scale:{x:0,y:0},
                      rotate: ((Math.random() * 720)-360) * (Math.PI / 180),
                    })
                    .to({
                        x:targetX,
                      y:Math.random()* gameScreenSize[1]/2,
                      alpha: 0,
                      scale:{x:randScale,y:randScale},
                      rotation:  ((Math.random() * 720)-360) * (Math.PI / 180),
                    });


                    
                }

                this.particleTween[i].time = 10000;
                this.particleTween[i].loop = false;
                this.particleTween[i].easing = PIXI.tween.Easing.linear();

            }
                
    //-create autoupdate
    for (let index = 0; index <  this.maxParticlesCount; index++) {
        let nextTween= this.particleTween[0];
        if( this.particleTween[index+1]!=undefined)
        {
          nextTween= this.particleTween[index+1];
        }
       
        this.particleTween[index].on('update', function (tween: PIXI.tween.Tween, totalTween:number, elapsedTime: number) {
          tween
          let startnewDelta=(1/totalTween);
        //   console.log(elapsedTime,startnewDelta,nextTween);
          if (elapsedTime > startnewDelta && nextTween.active==false){//1/totalTween && tween.active==false) { 
            nextTween.reset();
            nextTween.delay=0;
            // this.stop();
            nextTween.start();
            //   console.log('start new tween')
          }
     
      }.bind( this.particleTween[index], nextTween,  this.maxParticlesCount));
      }


      

    //   this.SetBlendModeScreen(true);
    }
   
    public stop=():void=>
    {
        for (let i = 0; i < this.particleSprite.length; i++) {
            this.particleTween[i].stop();
            this.particleTween[i].reset(); 
            this.parent.alpha=0;

        }
    }
    public Start=():void=>
    {     
         for (let i = 0; i < this.particleSprite.length; i++) {
        this.particleTween[i].reset(); 
        this.particleTween[i].delay =i*500;
        // console.log("delay",this.particleTween[i].delay)
        this.particleSprite[i].alpha=0;
     
        this.parent.alpha=1;
    }
    this.particleTween[0].start(); 
    }
    public setparticleMask=(newMask:PIXI.Sprite|PIXI.Graphics):void=>
    {

        for (let i = 0; i < this.particleSprite.length; i++) {
            
        this.particleSprite[i].mask=newMask;
        }
    }
    public SetBlendModeScreen=(booL: boolean):void=>
    {   
        for (let i = 0; i < this.particleSprite.length; i++) {
           if(booL)
           {
            this.particleSprite[i] .blendMode=PIXI.BLEND_MODES.ADD;
           }
           else
           {
            this.particleSprite[i] .blendMode=PIXI.BLEND_MODES.NORMAL;
           }
     
        }
    }

}